import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { FestivesFestivesListMaintenanceDto } from './FestivesFestivesListMaintenanceDto';
import { FestivesFestivesItemMaintenanceDto } from './FestivesFestivesItemMaintenanceDto';

@Injectable()
export class FestivesFestivesSubMaintenanceController extends BaseSubMaintenanceController<FestivesFestivesListMaintenanceDto, FestivesFestivesItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {
        super(http, alertService, translateService, loadingService, router, "festives/parent");
    }

    public getResourceRoot(): string {
        return "FESTIVES.PARENT";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/dataandparameters/festives/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}